import * as t from 'io-ts';

export const TripStatusDynamicType = t.union([
    t.literal('AwaitingQuotes'),
    t.literal('QuotesAvailable'),
    t.literal('CheckingAvailability'),
    t.literal('FlightPlanning'),
    t.literal('ItineraryAvailable'),
    t.literal('Expired'),
    t.literal('Flown'),
    t.literal('Enquiry'),
    t.literal('EnquiryExpired')
]);

export type TripStatus = t.TypeOf<typeof TripStatusDynamicType>;
